<template>
  <div>
    <!-- <v-row>
      <v-col cols="12" span="12">
        <v-icon color="success" large class="avatar-icon">mdi-numeric-2</v-icon><span class="pl-4 font-weight-light"><i>Configure the update to be executed</i></span>
      </v-col>        
    </v-row> -->

    <v-row dense class="ml-3 mt-4 sub-title">
      Select the price type you want to configure an update for
    </v-row>
    <v-row dense class="ml-3" style="border-top: solid 1px lightgrey;"> 
      <v-col cols="2">
        <div class="ml-3">
          <v-radio-group dense :value="pricetype" v-on:change="updatePriceType">
            <v-radio key='0' label="Purchase prices" :value=0></v-radio>
            <v-radio key='2' label="Sales prices" :value=2></v-radio>
          </v-radio-group>
        </div>
      </v-col>
      <v-col cols="2">
        <div class="ml-3">
          <v-radio-group dense :value="pricetype" v-on:change="updatePriceType">
            <v-radio key='1' label="Margin" :value=1></v-radio>
          </v-radio-group>
        </div>        
      </v-col>    
      <v-col cols="2">
        <div class="ml-3">
          <v-radio-group dense :value="pricetype" v-on:change="updatePriceType">
            <v-radio key='3' label="Minimum purchase prices" :value=3></v-radio>
            <v-radio key='4' label="Week prices" :value=4></v-radio>
          </v-radio-group>
        </div>        
      </v-col>                  
    </v-row>
    
    <v-row dense class="ml-3 sub-title">
      Parameters
    </v-row>    
    <v-row dense class="ml-3" style="border-top: solid 1px lightgrey;">
    </v-row>

    <div class="ml-3 mt-6">
      <v-checkbox
              dense
              v-model="wizardData.skipClosedDates"
              label="Ignore closed dates (skip 0-prices)"
              color="success"
              v-on:change="updateSkipClosedDates"
              hide-details
            ></v-checkbox>      
    </div>

    <div v-if="pricetype===0" class="ml-3 mt-4">
      <hsnp_wizard_step_02_purchase :wizardData="wizardData" @updateData="updateData"/>
    </div>
    <div v-else-if="pricetype===1" class="ml-3 mt-4">
      <hsnp_wizard_step_02_margin :wizardData="wizardData" @updateData="updateData"/>
    </div>
    <div v-else-if="pricetype===2" class="ml-3 mt-4">
      <hsnp_wizard_step_02_sales :wizardData="wizardData" @updateData="updateData"/>
    </div>
    <div v-else-if="pricetype===3" class="ml-3 mt-4">
      <hsnp_wizard_step_02_minpurchase :wizardData="wizardData" @updateData="updateData"/>
    </div>
    <div v-else class="ml-3 mt-4">
      <hsnp_wizard_step_02_weekprice :wizardData="wizardData" @updateData="updateData"/>
    </div>
    
  
  </div>
</template>

<script>

  import hsnp_wizard_step_02_purchase from '@/components/huis/hspt/hsnp/hsnp_wizard_step_02_purchase.vue';
  import hsnp_wizard_step_02_margin from '@/components/huis/hspt/hsnp/hsnp_wizard_step_02_margin.vue';
  import hsnp_wizard_step_02_sales from '@/components/huis/hspt/hsnp/hsnp_wizard_step_02_sales.vue';
  import hsnp_wizard_step_02_minpurchase from '@/components/huis/hspt/hsnp/hsnp_wizard_step_02_minpurchase.vue';
  import hsnp_wizard_step_02_weekprice from '@/components/huis/hspt/hsnp/hsnp_wizard_step_02_weekprice.vue';

  export default {
    props: {
      pricetype: Number, // because of initialisation we need to send this separately
      wizardData: Object
    },
    components: {
      hsnp_wizard_step_02_purchase,
      hsnp_wizard_step_02_margin,
      hsnp_wizard_step_02_sales,
      hsnp_wizard_step_02_minpurchase,
      hsnp_wizard_step_02_weekprice
    },
    methods:{
      updatePriceType(data){        
        this.updateData({"field": "price_type", "value": data});
      },
      updateSkipClosedDates(data){
        this.updateData({"field": "skipClosedDates", "value": data});
      },            
      updateData(data){
          this.$emit('updateData', data);      
      }
    }
  }  
</script>

<style scoped>
  .avatar-icon{
    border-radius: 200px;
    width: 30px;
    height: 30px;
    border: solid 2px green;
  }
  .sub-title{
    font-weight: bolder;
  }  
</style>